import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { SignatureStatsActiveContainer } from './SignatureStatsActiveContainer';
import { SignatureStatsClosedContainer } from './SignatureStatsClosed';

const SignatureStatsContainerInner: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker },
	} = usePetitionDetailsPageUserData();

	// MobileActionButton renders these above the share CTA instead — except for a decision maker,
	// whose respond action short-circuits that branch before it reaches the status.
	if (status === 'CLOSED') {
		return decisionMaker ? <SignatureStatsClosedContainer /> : null;
	}

	if (status === 'VICTORY') {
		return null;
	}

	return <SignatureStatsActiveContainer />;
};

export const SignatureStatsMobileContainer: React.FC<EmptyProps> = () => {
	return (
		<div className="my-4" data-qa="signature-stats-section">
			<SignatureStatsContainerInner />
		</div>
	);
};
